import { AddTourDeviationApproval } from "../../../domain/useages/tour-program-approval/add-tour-deviation-approval";
import { HttpConstants } from "../../protocols/http/http-constants";
import { HttpPutClient } from "../../protocols/http/http-put-client";

export class RemoteAddTourDeviationApproval implements AddTourDeviationApproval {
  constructor(
    private readonly url: string,
    private readonly httpPutClient: HttpPutClient
  ) {}

  async update(params: AddTourDeviationApproval.Params): Promise<any> {
    const httpResponse = await this.httpPutClient.put({
      url: this.url,
      body: params,
      headers: {
        [HttpConstants.CONTENT_TYPE]: HttpConstants.APPLICATION_JSON,
        [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
         [HttpConstants.APP_ID]: HttpConstants.APP_ID_VALUE,
      },
      authHeaders: true,
    });
    return httpResponse.data;
  }
}